/* eslint-disable max-len */
interface CalendarDescProps {
  className?: string;
  fill?: string;
  height?: string;
  width?: string;
}

const CalendarDesc = ({
  className = '',
  fill = '#0368A1',
  height = '18',
  width = '23',
  ...props
}: CalendarDescProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 23 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M20 14H23L19 18L15 14H18V0H20V14ZM7 13H10V10H7V13ZM12 2H11V0H9V2H5V0H3V2H2C0.89 2 0 2.89 0 4V15C0 16.11 0.89 17 2 17H12C13.11 17 14 16.11 14 15V4C14 2.89 13.11 2 12 2ZM2 15V8H12V15H2Z"
        fill={fill}
      />
    </svg>
  );
};

export default CalendarDesc;